import { render, staticRenderFns } from "./SimBajaIndividualPantalla.vue?vue&type=template&id=d49358d0&"
import script from "./SimBajaIndividualPantalla.vue?vue&type=script&lang=ts&"
export * from "./SimBajaIndividualPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d49358d0', component.options)
    } else {
      api.reload('d49358d0', component.options)
    }
    module.hot.accept("./SimBajaIndividualPantalla.vue?vue&type=template&id=d49358d0&", function () {
      api.rerender('d49358d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SimBajaIndividual/SimBajaIndividualPantalla.vue"
export default component.exports